export const LoadingSpinner = ({ label }: { label: string }) => (
  <div className="loader">
    <div className="loader-dot" aria-hidden="true" />
    <p className="hint">{label}</p>
  </div>
)
